(function () {
  'use strict';

  function createCollectionLightbox() {
    var existingLightbox = document.querySelector(
      '[data-collection-lightbox-dialog]'
    );

    if (existingLightbox) {
      return existingLightbox;
    }

    var lightbox = document.createElement('div');

    lightbox.className = 'collection-lightbox';
    lightbox.setAttribute('data-collection-lightbox-dialog', '');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.setAttribute('aria-label', 'Enlarged image');

    lightbox.innerHTML =
      '<button' +
        ' type="button"' +
        ' class="collection-lightbox__close"' +
        ' data-collection-lightbox-close' +
        ' aria-label="Close enlarged image"' +
      '>' +
        '&times;' +
      '</button>' +
      '<img' +
        ' class="collection-lightbox__image"' +
        ' data-collection-lightbox-image' +
        ' src=""' +
        ' alt=""' +
      '>';

    document.body.appendChild(lightbox);

    return lightbox;
  }

  function initialiseCollectionLightbox() {
    var lightbox = createCollectionLightbox();
    var lightboxImage = lightbox.querySelector(
      '[data-collection-lightbox-image]'
    );
    var closeButton = lightbox.querySelector(
      '[data-collection-lightbox-close]'
    );

    var lastTrigger = null;

    function openLightbox(trigger) {
      var sourceImage;

      if (trigger.tagName === 'IMG') {
        sourceImage = trigger;
      } else {
        sourceImage = trigger.querySelector('img');
      }

      if (!sourceImage) {
        return;
      }

      var source =
        sourceImage.currentSrc ||
        sourceImage.src ||
        sourceImage.getAttribute('src');

      if (!source) {
        return;
      }

      lastTrigger = trigger;

      lightboxImage.src = source;
      lightboxImage.alt = sourceImage.alt || '';

      lightbox.classList.add('is-open');
      lightbox.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';

      closeButton.focus();
    }

    function closeLightbox() {
      lightbox.classList.remove('is-open');
      lightbox.setAttribute('aria-hidden', 'true');

      lightboxImage.src = '';
      lightboxImage.alt = '';

      document.body.style.overflow = '';

      if (lastTrigger) {
        lastTrigger.focus();
      }
    }

    document.querySelectorAll('[data-collection-lightbox]').forEach(
      function (trigger) {
        if (trigger.getAttribute('data-collection-lightbox-ready') === 'true') {
          return;
        }

        trigger.setAttribute('data-collection-lightbox-ready', 'true');

        if (!trigger.hasAttribute('tabindex')) {
          trigger.setAttribute('tabindex', '0');
        }

        if (!trigger.hasAttribute('role')) {
          trigger.setAttribute('role', 'button');
        }

        if (!trigger.hasAttribute('aria-label')) {
          var image = trigger.tagName === 'IMG'
            ? trigger
            : trigger.querySelector('img');

          var imageName = image && image.alt
            ? image.alt
            : 'image';

          trigger.setAttribute(
            'aria-label',
            'Enlarge ' + imageName
          );
        }

        trigger.addEventListener('click', function (event) {
          event.preventDefault();
          openLightbox(trigger);
        });

        trigger.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            openLightbox(trigger);
          }
        });
      }
    );

    closeButton.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (
        event.key === 'Escape' &&
        lightbox.classList.contains('is-open')
      ) {
        closeLightbox();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initialiseCollectionLightbox
    );
  } else {
    initialiseCollectionLightbox();
  }
})();

(function () {
  'use strict';

  function initialiseCollectionGalleries() {
    document.querySelectorAll('[data-collection-gallery]').forEach(
      function (gallery) {
        if (gallery.dataset.galleryReady === 'true') {
          return;
        }

        var track = gallery.querySelector('[data-collection-gallery-track]');
        var previous = gallery.querySelector('[data-collection-gallery-previous]');
        var next = gallery.querySelector('[data-collection-gallery-next]');

        if (!track || !previous || !next) {
          return;
        }

        gallery.dataset.galleryReady = 'true';

        function moveGallery(direction) {
          var slides = track.querySelectorAll('.collection-gallery__slide');

          if (!slides.length) {
            return;
          }

          var distance = slides.length > 1
            ? slides[1].getBoundingClientRect().left -
              slides[0].getBoundingClientRect().left
            : slides[0].getBoundingClientRect().width;

          track.scrollBy({
            left: direction * distance,
            behavior: 'smooth'
          });
        }

        previous.addEventListener('click', function () {
          moveGallery(-1);
        });

        next.addEventListener('click', function () {
          moveGallery(1);
        });
      }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseCollectionGalleries);
  } else {
    initialiseCollectionGalleries();
  }
})();